import React from 'react';
import webCore from '@happylife-a/web-core';
import {
  Input,
  InputGroup,
  InputRightElement,
  InputLeftElement,
  Icon,
  Box,
  IconButton,
} from '@chakra-ui/react';
import { theme } from '../../../theme';

// # Variant details
// this is the copy of variant 1 with following differences
// - search icon is always visible from right
// - clear icon is in the right but visible only if there is value

export default function Variant8({ value, onChange, onKeyUp, setValue, isNotFound }) {
  const { t } = webCore.contexts.useTranslation();
  const hasValue = value.length > 0;

  return (
    <Box width="100%" maxW={{ base: '28px', md: '460px' }}>
      <InputGroup w="100%" display={{ base: 'none', md: 'flex' }}>
        <InputLeftElement pointerEvents="none" h={12} w={12}>
          <Icon
            as={isNotFound ? theme.icons.SearchIconPink : theme.icons.SearchIcon}
            fill="none"
            stroke={hasValue ? theme.colors.primary['500'] : 'white'}
            w={6}
            h={6}
          />
        </InputLeftElement>

        <Input
          h={12}
          type="text"
          placeholder={t('Search')}
          borderRadius="66px"
          bg={hasValue ? 'white' : 'rgba(255, 255, 255, 0.13);'}
          boxShadow={!isNotFound && '100'}
          _placeholder={{
            color: `${isNotFound ? 'primary.500' : 'white'}`,
          }}
          borderWidth={isNotFound ? 1 : 0}
          borderColor="grey.300"
          borderStyle="solid"
          _focus={{ boxShadow: 'none', borderColor: 'grey.300' }}
          _hover={{ borderColor: 'grey.300' }}
          value={value}
          onChange={onChange}
          onKeyUp={onKeyUp}
        />
        {hasValue && (
          <InputRightElement h={12} w={12} cursor="pointer" onClick={() => setValue('')}>
            <Icon as={theme.icons.CloseCircle} fill="none" w={6} h={6} />
          </InputRightElement>
        )}
      </InputGroup>
      <IconButton
        height="auto"
        minW="auto"
        variant="transparent"
        display={{ base: 'inline-flex', md: 'none' }}
        icon={<theme.icons.SearchIcon fill="none" w="28px" h="28px" />}
      />
    </Box>
  );
}
